import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from '@/Factories/BaseApiFactory';
import {PurchaserSummary, PurchaserSummaryFilter} from '@/models';

export class PurchaserService {
    static $inject = ['BaseApiFactory'];

    constructor(private readonly baseApiFactory: BaseApiFactory) {
    }

    getAll(query: PurchaserSummaryFilter, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<PurchaserSummary[]>('/v2/api/purchasers', query, cancelToken);
    }
}

lazyRegister.service('PurchaserService', PurchaserService);
